import { supabase } from './supabase';

// The state that exists so a permissions problem never presents as an empty catalogue. `is_admin()`
// returning false is RLS working exactly as designed (ADR 0033); showing an empty book list instead
// would send you debugging data access when the answer is the account.
export default function NotAdmin({ email }: { email: string | null }) {
  return (
    <main className="centered">
      <h1>Not an admin account</h1>
      <p>
        {email ? <strong>{email}</strong> : 'This account'} is signed in, but does not have admin
        access, so there is nothing here to show. This is a permissions state, not an error — sign
        in with the account that holds the admin role.
      </p>
      <button onClick={() => supabase.auth.signOut()}>Sign out</button>
    </main>
  );
}
